export const Work = [
    {
        id: 14,
        name:"Site em react para empresa de engenharia ATRIO",
        description:"Criação de site em reactjs para empresa de engenharia",
        tags:["site","portal","reactjs","atrio","siteengenharia"],
        demo:"https://atrioengenharia.net.br/",
        github:"https://github.com/brunoCarvalhoJr"
    },
    {
        id: 13,
        name:"API Login Com Google - GoogleApi + Reactjs + AspNet.CORE",
        description:"Modelo de aplicação de login utilizando conta do google - reactjs e AspNet.CORE",
        tags:["login","loginapi","reactjs","aspnetcore","aspnet"],
        demo:"https://github.com/brunoCarvalhoJr/LoginGoogleApi",
        github:"https://github.com/brunoCarvalhoJr/LoginGoogleApi"
    },
    {
        id: 12,
        name:"API Login - Reactjs + AspNet.CORE",
        description:"Modelo de aplicação com login de usuário utilizando reactjs e AspNet.CORE",
        tags:["login","loginapi","reactjs","aspnetcore","aspnet"],
        demo:"https://github.com/brunoCarvalhoJr/LoginApi",
        github:"https://github.com/brunoCarvalhoJr/LoginApi"
    },
    {
        id: 10,
        name:"Formulário de Login com transição Up/Down",
        description:"Um formulário de login clean com um transição Up/Down de animação",
        tags:["login-form","login","clean","transition","react"],
        demo:"https://login-form-up-transition.vercel.app/?email=&pswd=",
        github:"https://github.com/brunoCarvalhoJr/LoginFormUpTransition"
    },
    {
        id: 9,
        name:"Animação WhileTap e WhileHover com Framer-motion",
        description:"Animações com framer-motion",
        tags:["framer-motion","transition","react"],
        demo:"https://whiletap-whilehover-animate-framer-motion.vercel.app/",
        github:"https://github.com/brunoCarvalhoJr/whiletap-whilehover-animate-framer-motion"
    },
    {
        id: 8,
        name:"Cards animados com Framer-motion in ReactJs",
        description:"Animações de cards com framer-motion",
        tags:["framer-motion","transition","react"],
        demo:"https://cards-animation-framer-motion.vercel.app/",
        github:"https://github.com/brunoCarvalhoJr/Cards-animation-framer-motion/tree/main"
    },
    {
        id:7,
        name:"Carrossel de imagens em react e Styled-Component",
        description:"Carrossel de imagens em react e Styled-Component",
        tags:["carroussel","styled-component","react"],
        demo:"https://carousel-react-styled-comp.vercel.app/",
        github:"https://github.com/brunoCarvalhoJr/carousel-react-styled-comp"
    },
    {
        id:6,
        name:"Estrutura de  menu em react e Styled-Component",
        description:"Estrutura de menu com animações feita em react  e styled components",
        tags:["react","styled-component","structure"],
        demo:"https://structure-front-react-router-dom-styled-componet-menu-react.vercel.app/",
        github:"https://github.com/brunoCarvalhoJr/structure-front-react-router-dom-styled-componet"
    },
    {
        id:1,
        name:"Gerador Automatico  de Crud .NetCore/ReactJs",
        description:"React and ASP.NET-6,0 project to facilitate the generation of CRUDs and their files in DDD..",
        tags:["react","netcore","crudgenerator"],
        demo:"https://github.com/brunoCarvalhoJr/AutomatizeCRUDGenerator",
        github:"https://github.com/brunoCarvalhoJr/AutomatizeCRUDGenerator"
    },
    {
        id:2,
        name:"Exemplo de aplicação para gerenciamento de livros",
        description:"Exemplo de aplicação para gerenciamento de livros em APSNET-6.0 and REACTJS.",
        tags:["react","aspnet","aspnetCore","api"],
        demo:"https://github.com/brunoCarvalhoJr/example-reactjs-dotnet6-api",
        github:"https://github.com/brunoCarvalhoJr/example-reactjs-dotnet6-api"
        
    },
    {
        id:4,
        name:"Modelo de Projeto React/NetCore",
        description:"Um pequeno modelo base de projeto AspNet Core com ReactJs.",
        tags:["react","api","aspnetCore"],
        demo:"https://github.com/brunoCarvalhoJr/modelo-projeto-reactJs-aspnet",
        github:"https://github.com/brunoCarvalhoJr/modelo-projeto-reactJs-aspnet"
    },
    {
        id:5,
        name:"BoilerPlate React/TypeScript",
        description:"BoilerPlate React/TypeScript.",
        tags:["react","typescript","react-router"],
        demo:"https://github.com/brunoCarvalhoJr/boilerplate_react_typescript/",
        github:"https://github.com/brunoCarvalhoJr/boilerplate_react_typescript"
       
    }
] 